<template>
    <div class="cart pa-0">
        <v-row>
            <v-col cols="12" class="py-0">
                <heading-section class="d-flex">
                    <v-icon class="mr-1">mdi-cart-outline</v-icon>
                    {{ $vuetify.lang.t('$vuetify.widgets.cart.title') }}
                </heading-section>
            </v-col>

            <v-col cols="12" md="7" class="py-0 mb-6">
                <info-card v-if="cartEntries.length <= 0"
                           desc="$vuetify.widgets.cart.empty"></info-card>
                <cart-item-card v-else
                                v-for="cartEntry in cartEntries"
                                :key="cartEntry.id"
                                :item="cartEntry"></cart-item-card>
            </v-col>

            <v-col cols="12" md="5" class="py-0">
                <cart-account-overview :total="total"
                                       :user="currentUser"
                                       :has-digital-products="hasDigitalProducts"
                                       :has-physical-products="hasPhysicalProducts"
                ></cart-account-overview>
            </v-col>
        </v-row>
    </div>
</template>
<script>
// Components
import HeadingSection      from '../../components/HeadingSection';
import CartAccountOverview from '../../components/CartAccountOverview';
import CartItemCard        from '../../components/Cards/CartItem';
import InfoCard            from '../../components/Cards/Info';
// Models
import Cart                from '../../models/Cart';
import User                from '../../models/User';
// Utils
import { LOADER_CART, }    from '../../utils/constants';


export default {
    name:       'cart',
    components: {
        HeadingSection,
        CartItemCard,
        InfoCard,
        CartAccountOverview,
    },
    computed:   {
        isFetchingEntries() {
            return this.$wait.is(LOADER_CART);
        },
        cartEntries() {
            return Cart.getAll();
        },
        hasPhysicalProducts() {
            return Cart.isContainingPhysicalProducts();
        },
        hasDigitalProducts() {
            return Cart.isContainingDigitalProducts();
        },
        total() {
            return Cart.getTotal();
        },
        currentUser() {
            return User.getCurrent();
        },
    },
    mounted() {
        Cart.fetch();
    },
}
</script>
